module.exports = __webpack_public_path__ + "static/media/img02.7a2c2efa.webp";